"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("./Icon"));
var prop_types_1 = __importDefault(require("prop-types"));
require("./style.scss");
function SvgIcon(props) {
    var name = props.name, icon = Icon_1.default.find(function (item) { return item.name === name; }), Component = icon === null || icon === void 0 ? void 0 : icon.icon;
    return Component ? react_1.default.createElement(Component, __assign({}, props)) : null;
}
SvgIcon.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
    name: prop_types_1.default.string.isRequired,
    onClick: prop_types_1.default.func,
};
SvgIcon.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = SvgIcon;
